import noUiSlider from "nouislider";
import { Directive } from "vue";

type AppNouisliderElement = HTMLElement & {
    _appNouisliderInstance: {
        on: (...args: unknown[]) => void;
        destroy: (...args: unknown[]) => void;
        updateOptions: (...args: unknown[]) => void;
    };
};

const updatableOptions = [
    "margin",
    "padding",
    "limit",
    "step",
    "range",
    "pips",
    "tooltips",
    "animate",
    "snap",
];

const createSlider = (el: AppNouisliderElement, options: unknown) => {
    el._appNouisliderInstance = noUiSlider.create(el, options);
    el._appNouisliderInstance.on("change", (event: unknown) => {
        el.dispatchEvent(new CustomEvent("change", { detail: event }));
    });
};

export const appNouisliderDirective: Directive<
    AppNouisliderElement,
    Record<string, unknown>
> = {
    mounted(el, bindings) {
        createSlider(el, bindings.value);
    },
    unmounted(el) {
        el._appNouisliderInstance.destroy();
    },
    updated(el, bindings) {
        if (Object.keys(bindings.value).some((key) => !updatableOptions.includes(key))) {
            el._appNouisliderInstance.destroy();
            createSlider(el, bindings.value);
        } else {
            el._appNouisliderInstance.updateOptions(bindings.value, true);
        }
    },
};
